// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

//added sidechain
import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
  type: 'analytics',
  eventCategory: 'interaction',
  eventAction: 'click',
  eventLabel: 'etc'
})
//end sidechain

const $ = require('jquery');

function calculatePL(){
  console.log("hi");
  var residents =  $('#txtResidents').val();
  var income = parseInt($('#txtIncome').val());
  if (!income){
    alert('Please provide income');
  }
  else if (!residents){
    alert('Please provide number of residents');
  }

  $.ajax({
     async: false,
     url: 'https://fortress.wa.gov/atg/formhandler/ago/api/Values/GetPovertyLevel/',
     data: {
       residents: residents,
     },
     success: function (result) {
        $('#divResult').html('Provided income is <b>' + (income /result*100).toFixed(2) + '%</b> of the Federal Poverty Level for Washington residents ');
      },
    fail: function() {
      console.log("error");
    }
   });
   console.log("bye");
}

$( "#submit" ).click(function() {
  calculatePL();
});
